export default "__VITE_ASSET__9c0c9a1e__"